export default {
  '9': '9 - 0 , No Where To Go',
  '8': '8 - 1 , Have Some Fun',
  '7': '7 - 2 , Work To Do',
  '6': '6 - 3 , Better To Be Free',
  '5': '5 - 4 , Not A Relationship Anymore',
  '4': 'None'
}
